import { DEFAULT_LANGUAGE } from '../constants/i18n';
import { Nullable } from '../types/Base';

export function capitalize(str: string) {
  return `${str[0].toUpperCase()}${str.slice(1).toLowerCase()}`;
}

export function cleanSearchInput(str: string) {
  return str.replace(/ {2,}/g, ' ').trim();
}

export function removeSpaces(text: string) {
  return text.replace(/ {2,}/g, ' ').trimStart().trimEnd();
}

export function normalizeLanguage(lang: string | null) {
  const preferredLanguage = typeof lang === 'string' ? lang : DEFAULT_LANGUAGE;

  return preferredLanguage.replace('_', '-');
}

export function camelCaseToSnakeCase(str?: Nullable<string>) {
  if (!str) return str;

  return str.replace(/[A-Z]/g, letter => `_${letter.toLowerCase()}`);
}

export const cleanTolgeeText = (str: string) =>
  str
    .normalize('NFC') // Normalize Unicode (fixes encoding issues)
    .trim() // Remove extra spaces
    // eslint-disable-next-line no-misleading-character-class
    .replace(/[\u200B\u200C\u200D\uFEFF]/g, '') // Remove Zero-Width & BOM chars
    .replace(/\u00A0/g, ' ') // Replace non-breaking spaces with normal spaces
    .replace(/\s+/g, ' '); // Collapse multiple spaces

/**
 * Splits the text into lines that fit within the specified width.
 * @param text - The text to split.
 * @param maxCategoryWidth - The maximum width for each line.
 * @param measureText - Function to measure the width of the text.
 * @returns An array of lines that fit within the specified width.
 */
export function splitTextByWidth(
  text: string,
  maxCategoryWidth: number,
  measureText: (text: string) => number
): string[] {
  const words = text.split(' ');
  const lines: string[] = [];
  let currentLine = '';

  // eslint-disable-next-line no-restricted-syntax
  for (const word of words) {
    const testLine = currentLine ? `${currentLine} ${word}` : word;

    if (measureText(testLine) <= maxCategoryWidth) {
      currentLine = testLine;
    } else {
      if (currentLine) lines.push(currentLine);

      currentLine = word;
    }
  }

  if (currentLine) lines.push(currentLine);

  return lines;
}

export function truncateText(
  text: string,
  maxLength: number,
  ellipsis = '...'
): string {
  if (text.length <= maxLength) return text;

  return `${text.slice(0, maxLength)}${ellipsis}`;
}
